import { PUBLIC_ROUTES, PUBLIC_ROUTES_WITH_TOKEN } from '@app/session';

export const checkPublicRoutes = (pathname: string) => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);

  const token = params.get('token');

  return (
    PUBLIC_ROUTES.includes(pathname) ||
    (PUBLIC_ROUTES_WITH_TOKEN.includes(pathname) && !!token)
  );
};
